import React from "react";
import logger from "logger";
import TaskDialog from "TaskDialogCommon/TaskDialog";
import RunButton from "TaskDialogCommon/RunButton";
import TaskCheckBox from "TaskDialogCommon/TaskCheckBox";
import Instruction from "TaskDialogCommon/Instruction";
import TroopMapSelector from "TaskDialogCommon/TroopMapSelector";
import { CityNumberSelector } from "TaskDialogCommon/CityNumberSelector";
import { getLastConfigForTask } from "Utils/Common";

const taskname = "reassigntroops";

export default class Component extends React.Component {
  constructor(props) {
    super();
    const { accountdetailrow } = props;
    const initialState = {
      taskConfig: {
        accountdetail: accountdetailrow,
        sourceCityNumber: "",
        destinationCityNumber: "",
        alltroops: true,
        troops: {},
      },
    };
    logger.log(`loading ${taskname} dialog`, props);
    this.loadStoredData(initialState, props);
    logger.log("initialState after load", initialState);
    this.state = initialState;
  }

  validate = () => {
    return true;
  };

  loadStoredData = (initialState, props) => {
    const { taskConfig } = initialState;
    try {
      const { AccountDetailData: accountdetail } = props;
      var storeddata = getLastConfigForTask(taskname);
      logger.log("storeddata", storeddata, accountdetail);
      if (storeddata) {
        taskConfig.sourceCityNumber = storeddata.sourceCityNumber;
        taskConfig.destinationCityNumber = storeddata.destinationCityNumber;
        taskConfig.alltroops = storeddata.alltroops;
        taskConfig.troops = { ...storeddata.troops };
      }
    } catch (e) {
      logger.log(e);
    }
  };

  setValue = (event, key) => {
    const value = event.target.value;
    this.setState((s, p) => ({
      taskConfig: { ...s.taskConfig, [key]: value },
    }));
  };

  render = () => {
    const {
      setValue,
      validate,
      state: { taskConfig },
      props: { AccountDetailData },
    } = this;

    logger.log("here");

    return (
      <TaskDialog heading={"Reassign Troops"}>
        <CityNumberSelector
          label={"Source City"}
          param={"sourceCityNumber"}
          taskConfig={taskConfig}
          setValue={setValue}
          AccountDetailData={AccountDetailData}
        />
        <CityNumberSelector
          label={"Destination City"}
          param={"destinationCityNumber"}
          taskConfig={taskConfig}
          setValue={setValue}
          AccountDetailData={AccountDetailData}
        />

        <TaskCheckBox
          label={"Move all troops."}
          param={"alltroops"}
          taskConfig={taskConfig}
          setValue={setValue}
        />

        {!taskConfig.alltroops && (
          <TroopMapSelector
            AccountDetailData={AccountDetailData}
            taskConfig={taskConfig}
            setValue={setValue}
            label={"Select Troops to Transfer"}
            param={"troops"}
          />
        )}
        <Instruction>
          *Before running this task please try to ensure both the cities are
          close to each other. This way the troopreassign will use 1 min hour
          glasses and save the bigger hour glasses :-)
        </Instruction>
        <RunButton
          taskname={taskname}
          taskConfig={taskConfig}
          label={"Reassign Troops"}
          validate={validate}
        />
      </TaskDialog>
    );
  };
}
